import { Controller } from "@hotwired/stimulus"
import Choices from "choices.js"
import { postJson } from "../../utils/api"

export default class extends Controller {
  static targets = ["name", "category", "nameError", "categoryError", "additionalFields"]
  static values = { token: String, favourited: Boolean }

  connect() {
    this.observeName()
    if (this.hasCategoryTarget) {
      this.initCategory()
    }
  }

  disconnect() {
    if (this.categoryChoices) {
      this.categoryChoices.destroy()
    }
  }

  observeName() {
    this.nameTarget.addEventListener("input", this.toggleAdditionalFields.bind(this))
    this.toggleAdditionalFields()
  }

  toggleAdditionalFields() {
    if (this.nameTarget.value.length > 0) {
      this.additionalFieldsTarget.classList.remove("is-hidden")
      this.additionalFieldsTarget.classList.add("animate__animated", "animate__fadeIn")
      this.hideNameError()
    } else {
      this.additionalFieldsTarget.classList.add("is-hidden")
      this.additionalFieldsTarget.classList.remove("animate__animated", "animate__fadeIn")
      this.hideCategoryError()
    }
  }

  validateForm(event) {
    const hasName = this.nameTarget.value.trim().length > 0
    const hasCategory = this.hasCategoryTarget ? this.categoryTarget.value !== '' : true

    let isValid = true

    if (!hasName) {
      event.preventDefault()
      this.showNameError()
      isValid = false
    } else {
      this.hideNameError()
    }

    if (this.hasCategoryTarget && !hasCategory) {
      event.preventDefault()
      this.showCategoryError()
      isValid = false
    } else if (this.hasCategoryTarget) {
      this.hideCategoryError()
    }

    return isValid
  }

  showNameError() {
    if (this.hasNameErrorTarget) {
      this.nameErrorTarget.classList.remove("is-hidden")
    }
  }

  hideNameError() {
    if (this.hasNameErrorTarget) {
      this.nameErrorTarget.classList.add("is-hidden")
    }
  }

  showCategoryError() {
    if (this.hasCategoryErrorTarget) {
      this.categoryErrorTarget.classList.remove("is-hidden")
    }
  }

  hideCategoryError() {
    if (this.hasCategoryErrorTarget) {
      this.categoryErrorTarget.classList.add("is-hidden")
    }
  }

  initCategory() {
    fetch("/categories.json")
      .then(response => response.json())
      .then(data => {
        this.setupCategory(data)
      })
  }

  setupCategory(categories) {
    this.categoryChoices = new Choices(this.categoryTarget, {
      choices: categories,
      searchFields: ['label']
    })

    // Listen for category selection changes to hide error
    this.categoryTarget.addEventListener('change', () => {
      this.hideCategoryError()
    })
  }

  toggleFavourite(event) {
    event.preventDefault()
    const button = event.currentTarget
    const icon = button.querySelector('i')
    const token = this.tokenValue

    if (!token) {
      console.error('No token found')
      return
    }

    postJson(`/r/${token}/toggle_favourite`, {})
    .then(data => {
      if (data.success) {
        // Update icon
        if (icon) {
          if (data.favourited) {
            icon.classList.remove('fa-regular')
            icon.classList.add('fa-solid')
          } else {
            icon.classList.remove('fa-solid')
            icon.classList.add('fa-regular')
          }

          // Add pulse animation
          icon.classList.add('is-pulsing')
          setTimeout(() => {
            icon.classList.remove('is-pulsing')
          }, 200)
        }

        // Update the data attribute
        this.favouritedValue = data.favourited
      } else {
        console.error('Failed to toggle favourite:', data.error)
      }
    })
    .catch(error => {
      console.error('Error toggling favourite:', error)
    })
  }
}
